<!--
 * @version: V1.0.0
 * @Date: 2023-08-14 16:25:54
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-10 11:05:25
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\material\components\batchBind.vue
 * @Descripttion:
-->
<!--  -->
<template>
  <el-drawer v-loading.fullscreen="loading" :visible="visible" size="75%" :destroy-on-close="true"
    :wrapper-closable="false" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
    <div slot="title">
      <div style="display: flex;justify-content: space-between;">
        <div>批量绑定DI</div>
        <div>
          <el-button type="primary" @click="handleBind"> 绑定DI </el-button>
          <el-button plain  @click="$emit('close')"> 返回 </el-button>
        </div>
      </div>
    </div>

    <el-form ref="form" :model="form" label-width="0">
      <el-table :data="form.dataList" border>
        <el-table-column label="物料编码" prop="materialCode" />
        <el-table-column label="物料名称" prop="materialName" />
        <el-table-column label="规格型号" prop="specification" show-overflow-tooltip/>
        <el-table-column label="绑定DI码" width="600">
          <template slot-scope="{ row, $index }">
            <el-form-item :rules="rules.diCode" :prop="`dataList.${$index}.diCodeText`">
              <el-input v-model="row.diCodeText" readonly placeholder="请选择DI码" clearable @click.native="showUdiSelect($index)" />
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <DISelect v-if="selectDialog" :visible="selectDialog" @getData="getData" @update:loading="loading = $event"
      @close="selectDialog = false" />
  </el-drawer>
</template>

<script>
import { materialBind } from '@/api/material'
import DISelect from './DISelect.vue'

export default {
  name: 'MaterailBatchBind',
  components: {
    DISelect
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    },
    materialDataList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    // 这里存放数据
    return {
      loading: false,
      selectDialog: false,
      currentIndex: null, // 当前操作项
      form: {
        dataList: []
      },
      rules: {
        diCode: [
          {
            required: true,
            message: '请选择DI码',
            trigger: ['change']
          }
        ]
      }
    }
  },
  mounted() {
    this.form.dataList = JSON.parse(JSON.stringify(this.materialDataList))
  },
  // 方法集合
  methods: {
    // 处理绑定DI
    handleBind() {
      this.$refs.form.validate().then((valid) => {
        if (!valid) return
        this.loading = true
        const list = this.form.dataList.map(({ diCode,packLevel,description, diId, materialCode, id }) => {
          return { diCode, diId, materialCode,packLevel,description, id }
        })
        materialBind(list)
          .then(() => {
            this.$message.success('绑定成功')
            this.$emit('close')
          })
          .finally(() => {
            this.loading = false
          })
      })
    },
    // 处理di选择弹窗展示
    showUdiSelect(index) {
      this.selectDialog = true
      this.currentIndex = index
    },
    // 处理弹窗DI确认选择
    getData(data) {
      if (this.form.dataList.some((item) => item.diId === data.id)) {
        this.$message.error('该DI已被本页其他物料选择')
      } else {
        this.$set(this.form.dataList[this.currentIndex], 'diCodeText', data.productName+'_'+data.productSpecification+'_'+data.code)
        this.$set(this.form.dataList[this.currentIndex], 'diCode', data.code)
        this.$set(this.form.dataList[this.currentIndex], 'diId', data.id)
        this.$set(this.form.dataList[this.currentIndex], 'productName', data.productName)
        this.$set(this.form.dataList[this.currentIndex], 'packLevel', data.packLevel)
        this.$set(this.form.dataList[this.currentIndex], 'description', data.description)

        this.selectDialog = false
      }
    }
  }
}
</script>
